import { render, staticRenderFns } from "./OrganizationInspectionAttachmentsList.vue?vue&type=template&id=c38b5552&"
import script from "./OrganizationInspectionAttachmentsList.vue?vue&type=script&lang=js&"
export * from "./OrganizationInspectionAttachmentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports